module.exports = __webpack_public_path__ + "img/mesh-right.12c2b84b.png";